import { Switch } from "antd";
import { useEffect, useRef, useState, useContext } from "react";
import styles from './index.module.scss'
import EditIcon from '../../../assets/icons/EditIcon'
import TrashIcon from '../../../assets/icons/TrashIcon'
import ShareIcon from "../../../assets/icons/ShareIcon";
import RcmpModalInfo from "../../organisms/ModalInfo";
import intl from 'react-intl-universal'
import ModalConfirmDelete from "../../organisms/ModalAddPainelCancel";
import BoardContext from "../../../contexts/Board";
import FormContext from "../../../contexts/Form";
import automationContext from "../../../contexts/Automation";
import ClockIcon from "../../../assets/icons/ClockIcon";
import ClockRotateIcon from "../../../assets/icons/ClockRotateIcon";
import RcmpActivityHistory from "../../organisms/ModalAddActivity/ActivityHistory";
import RcmpModalAdd from "../ModalAdd";
import { toast } from "@stardust-ds/react";
import RcmpHistoryModal from "../History";
import RcmpLoading from "../../atoms/Loading";
import RcmpAlertIcon from "../../../assets/icons/AlertIcon";

export default function RcmpActionFormCollection(props) {
    const { cDisabledText, cAbleText, bSingleOption, disabled, form, fnChangeStatus, fnDelete, fnUpdate, bIsAutomation, fnOnCloseModalList, fnOpenHistoryModal, type, ...oRest } = props
    const [isChecked, setIsChecked] = useState(false)
    const [bIsOpenModalInfoSwitch, fnSetBIsOpenModalInfoSwitch] = useState(false)
    const [bIsDeleteForm, fnSetBIsDeleteForm] = useState(false)
    const [bOpenModalDelete, fnSetBOpenModalDelete] = useState(false)
    const [nAutomationId, fnSetNAutomationId] = useState(-1)
    const [bIsOpenHistoryModal, fnSetBIsOpenHistoryModal] = useState(false)
    const [bShowLoadingOpenModal, fnSetBShowLoadingOpenModal] = useState(false)
    const { fnOpenShareForm } = useContext(FormContext)
    const { fnOpenShareAutomation, bOpenNewAutomation, oAutomation, oUpdateAutomationRes, bActiveAutomation } = useContext(automationContext)
    const textModalInfoInactive = bIsAutomation ? intl.get("modal_new_automation.info_inactive_form_automation", { automation: form?.title }) : intl.get("modal_form_list.info_inactive_form", { form: form?.formName })
    const textModalInfoDelete = bIsAutomation ? intl.get("modal_new_automation.info_delete_form_automation", { automation: form?.title }) : intl.get("modal_form_list.info_delete_form", { form: form?.formName })

    const { oCurrentBoard } = useContext(BoardContext)

    const elSwitchContainer = useRef(null)

    function fnShare() {
        if (!bIsAutomation) {
            fnOpenShareForm(form)
            return
        } else {
            fnOpenShareAutomation(form)
        }

    }

    function fnOpenToastFail() {
        return toast({
            type: "error",
            title: intl.get("table_fields.toast.fail"),
            description: intl.get("automation_list_activities.active_automation_fail")
        })
    }

    useEffect(() => {
        // set button type as button
        if (!elSwitchContainer?.current?.children?.length) return;

        [...elSwitchContainer.current.children].map(el => {
            if (el?.type === "submit") el.type = "button"
        })
    }, [])

    useEffect(() => {
        if (!form) return

        if (bIsAutomation) {
            setIsChecked(Boolean(form.status))
            return

        }

        setIsChecked(Boolean(form.isActive))
    }, [form?.isActive])

    useEffect(() => {
        if (bOpenNewAutomation) {
            fnSetNAutomationId(oAutomation.id)
            fnSetBShowLoadingOpenModal(false)
            return
        }

        if (form.id === nAutomationId && !bOpenNewAutomation && !oUpdateAutomationRes?.data?.success && bActiveAutomation) {
            setIsChecked(false)
            fnSetNAutomationId(-1)
            fnOpenToastFail()
        }
        if (form.id === nAutomationId && !bOpenNewAutomation && oUpdateAutomationRes?.data?.success && bActiveAutomation) {
            setIsChecked(true)
            fnSetNAutomationId(-1)
            fnOpenToastFail()
        }
    }, [bOpenNewAutomation, oAutomation])

    function fnOnChangeSwitch(bStatus) {
        if (!isChecked && bIsAutomation) {
            fnUpdate(form, true)
            fnSetBShowLoadingOpenModal(true)
            return
        }
        setIsChecked(bStatus)
        fnSetBIsOpenModalInfoSwitch(true)
    }

    function fnCloseMOdalInfoSwitch() {
        fnSetBIsOpenModalInfoSwitch(false)

        setIsChecked(prev => !prev)
    }
    async function fnConfirmModalInfoSwitch() {
        // request to change status
        if (typeof fnChangeStatus === "function" && !bIsAutomation) {
            await fnChangeStatus(form, isChecked)
            fnSetBIsOpenModalInfoSwitch(false)
            return
        }
        if (typeof fnChangeStatus === "function" && bIsAutomation && !isChecked) {
            await fnChangeStatus(form, isChecked)
            fnSetBIsOpenModalInfoSwitch(false)
            return
        }

    }

    function fnOpenDeleteFormModalInfo() {
        fnSetBIsOpenModalInfoSwitch(true)
        fnSetBIsDeleteForm(true)
    }

    function fnConfirmDeleteModalInfo() {
        fnSetBIsOpenModalInfoSwitch(false)
        fnSetBOpenModalDelete(true)
    }
    function fnCancelDeleteModalInfo() {
        fnSetBIsOpenModalInfoSwitch(false)
        fnSetBIsDeleteForm(false)
        fnSetBOpenModalDelete(false)
    }

    async function fnConfirmDelete(cPassword) {
        if (typeof fnDelete === "function" && !bIsAutomation) {
            return await fnDelete(form.id, cPassword)
        } else {
            return await fnDelete(form.id, cPassword)
        }
    }

    function fnHandleUpdate() {
        fnUpdate(form)
    }
    const cContainerClasses = `${styles.actionsContainer} ${bSingleOption ? styles.switchContainerSingle : ""} ${disabled ? styles.disabled : ""}`
    return (
        <div ref={elSwitchContainer} className={cContainerClasses}>

            {oCurrentBoard?.bIsResponsible && !bShowLoadingOpenModal && (
                <Switch
                    checked={isChecked}
                    onChange={(e) => fnOnChangeSwitch(e)}
                    className={
                        !isChecked ? styles.switchComponentDisabled : styles.switchComponent
                    }
                    disabled={disabled}
                    {...oRest}
                />

            )}
            {bShowLoadingOpenModal &&
                <div className={styles.spinnerContainer}>
                    <RcmpLoading bShow={true} size={20} />
                </div>
            }


            
            <ClockRotateIcon fill={"#6CB6E3"} onClick={() => fnOpenHistoryModal(form)} />
            {oCurrentBoard?.bIsResponsible && (
                <>
                    <EditIcon width={20} height={20} fill={"#1ECB4F"} onClick={fnHandleUpdate} />
                    <TrashIcon fill={"#FF3541"} width={20} height={20} onClick={fnOpenDeleteFormModalInfo} />
                </>
            )}

            <RcmpModalInfo
                size={"sm"}
                bIsOpen={bIsOpenModalInfoSwitch}
                description={bIsDeleteForm ? textModalInfoDelete : textModalInfoInactive}
                subText={bIsDeleteForm && intl.get("confirm_operation")}
                buttonSaveText={intl.get("continue")}
                title={intl.get("warning")}
                fnHandleConfirm={bIsDeleteForm ? fnConfirmDeleteModalInfo : fnConfirmModalInfoSwitch}
                fnHandleCancel={bIsDeleteForm ? fnCancelDeleteModalInfo : fnCloseMOdalInfoSwitch}
            />
            <ModalConfirmDelete
                isOpen={bOpenModalDelete}
                fnOnClose={fnCancelDeleteModalInfo}
                fnHandleDelete={fnConfirmDelete}
                bOnDelete={true}
                headerText={!bIsAutomation ? intl.get("modal_form_list.delete_form") : intl.get("modal_automation_list.delete_automation")}
                text={!bIsAutomation ? intl.get("modal_form_list.info_delete_form", { form: form?.formName }) : intl.get("modal_new_automation.info_delete_form_automation", { automation: form?.title })}
            />
             <ShareIcon fill={"#6CB6E3"} style={{ opacity: type === "notification_trigger" ? ".5" : "1", cursor: type === "notification_trigger" ? "not-allowed" : "pointer" }} onClick={type === "notification_trigger" ? () => { } : fnShare} />


        </div>

    )
}